<template>
  <div
    class="restyle-menu"
    @mouseenter="removeFocus()"
    :class="{'position-relative': viewNewYear}"
  > 
    <div class="position-absolute top-0 start-0 z-index-0 h-100" v-if="viewNewYear">
      <img src="@/assets/new_year_2024/menu_snowflake.svg" class="h-100" style="object-fit: cover;" alt="" >
    </div>
    <icons_menu style="position: fixed; top: -100px;" />
    <div class="position-absolute top-0 start-0" v-if="viewNewYear">
      <img src="@/assets/new_year_2024/menu_garland.svg" alt="">
      <img src="@/assets/new_year_2024/menu_christmas_tree.svg" class="position-absolute" alt="" style="top: 24px; left: 5px;">
    </div>
    <div class="menu-left-wrapper">
      <router-link to="/" class="logo-wrapper">
        <template v-if="isWideScreen">
          <span class="logotip-full">
            <img
              src="@/assets/restyle/images/new_logo.svg"
              alt=""
              class="logotip-full-img"
              key="logo"
            />
          </span>
          <span class="home-link">Факт</span>
        </template>
        <img
          v-else
          src="@/assets/boss_instruction/SmartRO Mini.svg"
          alt=""
          class="logo-mini-img"
        />
      </router-link>
      <links />
    </div>
    <div class="wrapper-right-menu" :class="{
      'ms-35': !isShowFullMenu
    }">
      <gserver v-if="isShowFullMenu" :back_office="back_office"/>
      <tech v-if="isShowFullMenu" />
      <div class="bell"
        @mouseenter="setIsVisibleNotPopup(true)">
        <img
          class="bell__img"
          src="@/assets/restyle/images/menu/bell.png"
          alt=""
        >
        <div v-if="getListNotifications.length" class="bell__count">
          {{ getListNotifications.length }}
        </div>
      </div>
      <user-menu />
    </div>
  </div>
</template>

<script>
import icons_menu from "./icons.vue";
import userMenu from "@/components/UserMenu";
import links from "./links";
import tech from "./blocks/tech";
import gserver from "./blocks/gserver.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    icons_menu,
    userMenu,
    links,
    tech,
    gserver,
  },
  data() {
    return {
      activeItem: null,
      isAtiveCursorUrlLogistick: false,
      isWideScreen: window.innerWidth > 1500,
    };
  },
  methods: {
    ...mapMutations({
      setIsVisibleNotPopup: "user_notifications/SET_IS_VISIBLE_NOTIFICATIONS_POPUP",
    }),
    removeFocus() {
      document.activeElement.blur();
    },
  },
  computed: {
    ...mapGetters({
      userCan: "user/userCan",
      viewNewYear: "new_year_store/viewNewYear",
      getListNotifications: "user_notifications/GET_LIST_NOTIFICATIONS",
    }),
    back_office() {
      return this.userCan('technical_department_root') || Boolean(process.env.VUE_APP_LOCAL_DEV);
    },
    isShowFullMenu() {
      return this.userCan('superadmin') || this.back_office;
    }
  },
};
</script>

<style lang="scss" scoped>

.menu-left-wrapper {
  display: flex;
  gap: 20px;
}

.logo-wrapper {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 0 0 auto;
}

.restyle-menu {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  height: 100%;
  background: linear-gradient(90.04deg, #1D9C95 0%, #1D106F 100%);
  padding: 0 20px 0 30px;
}

.logotip-full {
  flex: 0 0 auto;
  display: inline-block;
  padding: 14px 0;

  &-img {
    height: 22px;
  }
}

.home-link {
  margin-left: 9px;
  display: inline-block;
  font-weight: 400;
  font-size: 19px;
  line-height: 26px;
  color: #FFFFFF;
  vertical-align: sub;

  & a {
    margin-left: 9px;
    display: inline-block;
    font-weight: 400;
    font-size: 19px;
    line-height: 26px;
    color: #FFFFFF;
    vertical-align: sub;
  }
}

.bell {
  position: relative;
  cursor: pointer;
  flex: 0 0 auto;
  &__img {
    height: 23px;
    width: 23px;
  }
  &__count {
    position: absolute;
    top: -3px;
    right: 4px;
    background-color: red;
    color: white;
    border-radius: 15px;
    font-size: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  }
}

.wrapper-right-menu {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ms-35 {
  margin-left: 35px !important;
}

@media (min-width: 1650px) {
  .menu-left-wrapper {
    gap: 90px;
  }
  .all-links {
    gap: 35px;
  }
}

@media (max-width: 1270px) {
  .restyle-menu {
    padding-left: 5px;
    padding-right: 5px;
  }
  
}

@media (max-width: 576px) {
  .restyle-menu {
      display: none !important;
    }
}
</style>